import script from "./ListaHorarioAlumno.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaHorarioAlumno.vue?vue&type=script&setup=true&lang=js"

import "./ListaHorarioAlumno.vue?vue&type=style&index=0&id=55923748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55923748"]])

export default __exports__